import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import PropTypes from "prop-types";
import { AiOutlineSync } from 'react-icons/ai';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//redux
import TableContainerV1 from "../../components/Common/TableContainerV1"

// Column
import {
  Id, CategoryName, CategoryDescription, CategoryCode
} from './categoryCol';

import { getCategoryList, deleteCategory } from "helpers/UAM/category.helper";

import DeleteModal from "components/Common/DeleteModal";
import ToastDialog from "components/Common/ToastDialog";
import { getGeneralMaster } from "http/master/master";
import { formatDateTime, isPermission } from "common/utility";
import { getApiLogs } from "http/apiLogs/apiLogs";
import FullPageLoader from "components/Common/FullPageLoader";

const TableActionsComponent = (rowData, handleDeleteCategory = null) => {
  const navigate = useNavigate();

  const {roleName} = JSON.parse(localStorage.getItem("user"))

  const navigateToeViewCategory = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/listCategory/view?id=${encodeURIComponent(encryptedId)}`)
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            navigateToeViewCategory(rowData.id)
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="edittooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>

      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const Category = (props) => {


  //meta title
  document.title = "Category List | DMS";

  const navigate = useNavigate();

  const [categoryData, setCategoryData] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({ column: "id", isAsc: false, optionalColumn: ['categoryDescription', 'Action'], });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncPermission, setSyncPermission] = useState(false);

  // Customber Column
  const [lastSynced, setLastSynced] = useState(null);

  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return <Id {...cellProps} />;
          ;
        }
      },
      {
        Header: 'Category Code',
        accessor: 'categoryCode',
        filterable: true,
        Cell: (cellProps) => {
          return <CategoryCode {...cellProps} />;
        }
      },
      {
        Header: 'Category Name',
        accessor: 'categoryName',
        filterable: true,
        Cell: (cellProps) => {
          return <CategoryName {...cellProps} />;
        }
      },
      {
        Header: 'Category Description',
        accessor: 'categoryDescription',
        filterable: true,
        Cell: (cellProps) => {
          return <CategoryDescription {...cellProps} />;
          ;
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, handleDeleteCategory)

        }
      },
    ],
    []
  );

  const handleDeleteCategory = (id) => {
    setDeleteItemId(id)
    setDeleteModal(true)
  }

  const deleteCategoryHelper = () => {
    deleteCategory({ id: deleteItemId })
      .then((response) => {
        if (response.status && response.code == 201) {
          setDeleteModal(false)
          fetchCategoryData();
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
  useEffect(() => {
    fetchCategoryData()
    fetchLastSynced()
    checkPermission()
  }, [])

  const checkPermission = async () => {
    let isSyncPermission = await isPermission('sync', 'create_permission')
    setSyncPermission(isSyncPermission)
  }

  const fetchCategoryData = () => {
    getCategoryList()
      .then((responeFromApi) => {
        if (responeFromApi.status && responeFromApi.code == 200) {
          setCategoryData(responeFromApi.data?.data);
          const { totalItems, totalPages, currentPage } = responeFromApi.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        }
      })
      .catch((err) => { console.log(err) })
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    getCategoryList({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setCategoryData(responseFromAPI.data.data)
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setCategoryData([])
        }
      })
      .catch(error => {
        console.log(error)
      })

  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };


  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "", "id", "desc");
  };

  const handleCustomerClicks = () => {
    navigate(`/admin/listCategory/add`)
  };


  const checkAdminStatus = () => {
    return (window.location.pathname == "/admin/listCategory")
  }

  const handleSync = async () => {
    setIsSyncing(true);
    try {
      let res = await getGeneralMaster({ masterName: 'category' })
      if (res.status) {
        setToastInfo({
          message: res.message,
          showToast: true,
          role: "success",
        })
        fetchCategoryData()
        setIsSyncing(false);
        fetchLastSynced()
      } else {
        setToastInfo({
          message: "Something went wrong",
          showToast: true,
          role: "error",
        })
        setIsSyncing(false);
      }

    } catch (err) {
      setToastInfo({
        message: "Something went wrong",
        showToast: true,
        role: "error",
      })
      setIsSyncing(false);
    }
  }

  const fetchLastSynced = async () => {
    try {
      let res = await getApiLogs({ masterName: 'category_master' })
      if (res.status) {
        setLastSynced(formatDateTime(res.data.initialDateTime))
      }
    } catch (err) {
      console.error(err)
    }
  }
  const buttonSection = (
    <>
      {syncPermission && (<div>
        <div className="d-flex justify-content-end mb-1">
          <button
            className="btn btn-success"
            type="button"
            onClick={handleSync}
          >
            <AiOutlineSync size={15} className={isSyncing ? 'rotating' : ''} /> Sync Data
          </button>
        </div>
        {lastSynced && <p className="d-flex justify-content-end ">Last Synced: {lastSynced}</p>}
      </div>)}

    </>

  )

  const userIsAdmin = checkAdminStatus()
  return (
    <React.Fragment>
      {isSyncing && <FullPageLoader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Category" breadcrumbItem="Category List" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerV1
                    columns={columns}
                    data={categoryData}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    searchHelperText={"Seach by Category Name and Category Code"}
                    sortOptions={sortingOptions}
                    handleClearSearch={handleClearSearch}
                    isGlobalFilter={true}
                    customSection={buttonSection}
                    userIsAdmin={userIsAdmin}
                    handleSortColumn={handleSortColumn}
                    handleCustomerClick={handleCustomerClicks}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={deleteCategoryHelper}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  );
};

Category.propTypes = {
  customers: PropTypes.array,
  onGetCustomers: PropTypes.func,
  onAddNewCustomer: PropTypes.func,
  onDeleteCustomer: PropTypes.func,
  onUpdateCustomer: PropTypes.func,
};

export default Category;